import React from 'react'

import { Icon, ErrorOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const iconSize = { height: '100px', width: '100px' }

function ErrorState({ error }) {
  const t = useTranslation()

  return (
    <div className="viewer-overlay">
      <Icon svgComponent={ErrorOutlined} color="warning" size={iconSize} notSpaced />
      <span className="viewer-overlay__title">{t('viewer.canvas.failedToStart')}</span>
      <p>{error}</p>
    </div>
  )
}

ErrorState.propTypes = {
  error: string.isRequired,
}

export default ErrorState
